
export default {
  install(Vue) {
    // 闪现在用版本，需替换
    Vue.prototype.$pluginSparkReport = {
      async init() {
        // 插入上报库的js文件
      },
      async click(params) {
        console.log('tgclub report.click, params=', params);
      },
      async expose(params) {
        console.log('tgclub report.expose, params=', params);
      },
      async module(params) {
        console.log('tgclub report.module, params=', params);
      },
      //  除了click、expose、module 3个必需的方法，还可以定义更多方法供手动调用
      async report(reportPv = '', sxEventtype, sxExtendid) { // 闪现活动上报
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        const [sxContentid, sxContentname] = reportPv.split('|');
        window?.gameCommunityJsSdk?.report({
          pageid: '2501',
          moduleid: '00001',
          eventtype: sxEventtype,
          extendid: sxExtendid,
          contentid: sxContentid,
          contentname: sxContentname,
        });
      },
      async sparkBaseReport(reportPv = '', sxPageid, sxModuleid, sxEventtype, sxExtendid) { // 闪现活动上报
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        const [sxContentid, sxContentname] = reportPv.split('|');
        window?.gameCommunityJsSdk?.report({
          pageid: sxPageid,
          moduleid: sxModuleid,
          eventtype: sxEventtype,
          extendid: sxExtendid,
          contentid: sxContentid,
          contentname: sxContentname,
        });
      },
      async sparkBaseReportMerge(reportPv = '', sxPageid, sxModuleid, sxEventtype, sxExtendid, obj = {}) { // 闪现活动上包括自定义埋点
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        const [sxContentid, sxContentname] = reportPv.split('|');
        let maiDian = {
          pageid: sxPageid,
          moduleid: sxModuleid,
          eventtype: sxEventtype,
          extendid: sxExtendid,
          contentid: sxContentid,
          contentname: sxContentname,
        };
        if (obj !== {}) {
          maiDian = Object.assign(maiDian, obj);
        }
        window?.gameCommunityJsSdk?.report(maiDian);
      },
    };
    // 接入平台版本
    Vue.prototype.$reportSparkPlugin = {
      async init() {
        // 插入上报库的js文件
      },
      async click(params) {
        console.log('tgclub report.click, params=', params);
      },
      async expose(params) {
        console.log('tgclub report.expose, params=', params);
      },
      async module(params) {
        console.log('tgclub report.module, params=', params);
      },
      // 除了click、expose、module 3个必需的方法，还可以定义更多方法供手动调用
      async report(reportPv = '', sxEventtype, sxExtendid) { // 闪现活动上报
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        const [sxContentid, sxContentname] = reportPv.split('|');
        window?.gameCommunityJsSdk?.report({
          pageid: '2501',
          moduleid: '00001',
          eventtype: sxEventtype,
          extendid: sxExtendid,
          contentid: sxContentid,
          contentname: sxContentname,
        });
      },
      async sparkBaseReport(reportPv = '', sxPageid, sxModuleid, sxEventtype, sxExtendid) { // 闪现活动上报
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        const [sxContentid, sxContentname] = reportPv.split('|');
        window?.gameCommunityJsSdk?.report({
          pageid: sxPageid,
          moduleid: sxModuleid,
          eventtype: sxEventtype,
          extendid: sxExtendid,
          contentid: sxContentid,
          contentname: sxContentname,
        });
      },
      trackClick: async (trackClickOption) => {
        console.log('spark trackClickOption', trackClickOption);
        const actInfo = Vue.prototype.$actInfo;
        const pageId = actInfo.page_id;
        const { reportPv = '' } = actInfo.config.configs[pageId].canvasConfig;
        if (reportPv === '') {
          console.warn('missing reportPv param');
          return false;
        }
        // component_config: { report_pv, report_click }
        const { reportClick = '', reportExpose = '' } = trackClickOption?.component_config?.styles?.base;
        console.log({ reportClick, reportExpose });
        const { event_id: eventId, ext } = trackClickOption;
        // 点击事件
        if (reportClick && reportClick !== '') {
          if (eventId === '1045' && ext?.status === undefined) {
            console.log('上报点击事件', reportClick.split(','));
            const [type, id] = reportClick.split(',');
            Vue.prototype.$reportSparkPlugin.report(reportPv, type, id);
          }
        }
        // 成功事件
        if (reportExpose && reportExpose !== '') {
          if (ext?.status === '1') {
            console.log('上报抽奖、领取成功', reportExpose.split(','));
            const [type1, id1] = reportExpose.split(',');
            Vue.prototype.$reportSparkPlugin.report(reportPv, type1, id1);
          }
        }
      },
    };
  },
};
